import React from "react"
import { useTranslation } from "react-i18next"
import { CloseLarge, InfoFill } from "@/skylticons"

interface ResetTooltipProps {
  closeTooltip: () => void
}

const ResetTooltip: React.FC<ResetTooltipProps> = ({ closeTooltip }) => {
  const { t } = useTranslation()

  return (
    <div className="reset-tooltip absolute top-[67px] z-20 w-full md:w-[375px] lg:top-[60px]">
      <div className="ml-1 mr-2 flex items-center rounded-lg border bg-info-bg p-3 lg:mx-0">
        <span className="tooltip-arrow"></span>
        <InfoFill className="mr-3 text-info" />
        <div className="text-base">
          <div className="font-semibold">{t("signomatic.reset_tooltip_cta")}</div>
        </div>
        <button onClick={closeTooltip} className="button button-subtle icon-only m-0 !ml-auto" type="button">
          <CloseLarge />
        </button>
      </div>
    </div>
  )
}

export default ResetTooltip
